import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {HistorySearchParamType} from "../../pages/inventory/history/interface";

const url = "api/inventory/sub_function/";

export async function readInventoryHistory(param: HistorySearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory_history", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportHistoryExcel(param: HistorySearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_history_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}